<mf-page title="Nueva persona">
  <mf-natural-person
    [naturalPersonDto]="naturalPersonDto"
    (close)="close()"
    (save)="save($event)" />
</mf-page>
